import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import style from './style.less';
import tpl from './dom.html';

const { createUniqueId, throttle } = common;
const { $id } = dom;

const fixedTabBarStyle = style['fixedTabBar'];

const tabBarId = createUniqueId();

const CategoryTab = props => {
    
    const {
        activeTabKey,
        onSwitchTabKey,
        tab,
    } = props;
 
    const data = {
        tabBarId,
        tab,
        activeTabKey,
    }

    const events = {
        handleTabSwitch: (key) => {
            if (onSwitchTabKey) {
                onSwitchTabKey(key);
            }
        }
    };

    let scrollY = 0;
    let tabBarDom = null;
    const fixedTabBar = () => {
        const curScrollY = document.documentElement.scrollTop || document.body.scrollTop;
        tabBarDom = tabBarDom ? tabBarDom : $id(tabBarId);
        const toViewPortDistance = tabBarDom.getBoundingClientRect().top;
        
        if (toViewPortDistance < 20) {
            scrollY = scrollY ? scrollY : curScrollY;
            tabBarDom.classList.add(fixedTabBarStyle);
        }
        if (curScrollY < scrollY ) {
            tabBarDom.classList.remove(fixedTabBarStyle);
        }
    }
  
    if (!CSS.supports('position', 'sticky')) {
        window.addEventListener('scroll', throttle(fixedTabBar, 100));
    }
    
    
    const component = createComponent(tpl, { data, style }, events);

    return component;
}

const renderCategoryTab = (props) => {
    const component = CategoryTab({ ...props });
    
    if ($id(tabBarId).classList.contains(fixedTabBarStyle)) {
        $id(tabBarId).outerHTML = component;
        $id(tabBarId).classList.add(fixedTabBarStyle);
    } else {
        $id(tabBarId).outerHTML = component;
    }
    // $id(tabBarId).outerHTML = component;
    
}
export default CategoryTab;

export {
    renderCategoryTab
};